import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { S3Client, ListObjectsV2Command } from "@aws-sdk/client-s3-browser";

export default function LoadingPopover({ open, userId, onClose }) {
    const [folders, setFolders] = useState([]);
    const [folderStatus, setFolderStatus] = useState({});
    const intervalRef = useRef(null); // <-- เก็บ reference interval

    const bucketName = "sitgps";
    const prefix = userId;

    const s3 = new S3Client({
        endpoint: "https://01s3.sitgps.com",
        region: "us-east-1",
        credentials: {
            accessKeyId: "sit01",
            secretAccessKey: "Sit@2025",
        },
        forcePathStyle: true,
    });

    const getExpectedFileCount = (folderName) => {
        const match = folderName.match(/_(\d+)\/$/);
        return match ? parseInt(match[1], 10) : 0;
    };

    const fetchFolderFiles = async (folderPrefix) => {
        let allFiles = [];
        let token;
        while (true) {
            const res = await s3.send(new ListObjectsV2Command({
                Bucket: bucketName,
                Prefix: folderPrefix,
                ContinuationToken: token,
            }));
            allFiles.push(...(res.Contents || []));
            if (!res.IsTruncated) break;
            token = res.NextContinuationToken;
        }
        return allFiles;
    };

    const loadStatus = async () => {
        // ---- รีเซ็ต interval เพื่อเริ่มนับใหม่ ----
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
        }
        intervalRef.current = setInterval(() => {
            loadStatusInternal();
        }, 5000);

        // โหลด status รอบแรกทันที
        await loadStatusInternal();
    };

    const loadStatusInternal = async () => {
        let allFolders = [];
        let token;
        while (true) {
            const res = await s3.send(new ListObjectsV2Command({
                Bucket: bucketName,
                Prefix: `upload/${prefix}/`,
                Delimiter: "/",
                ContinuationToken: token,
            }));
            const folderNames = (res.CommonPrefixes || []).map(p => p.Prefix);
            allFolders.push(...folderNames);
            if (!res.IsTruncated) break;
            token = res.NextContinuationToken;
        }

        setFolders(allFolders);

        const statusObj = {};
        await Promise.all(
            allFolders.map(async (folder) => {
                const expectedCount = getExpectedFileCount(folder);
                const filesInFolder = await fetchFolderFiles(folder);
                statusObj[folder] = {
                    filesCount: filesInFolder.length,
                    canDownload: filesInFolder.length >= expectedCount
                };
            })
        );
        setFolderStatus(statusObj);
    };

    useEffect(() => {
        if (open) {
            loadStatus();
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        }
        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
        }
    }, [open]);

    // Base64-safe (รองรับ Unicode)
    const toBase64 = (str) => window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
        String.fromCharCode(parseInt(p1, 16))
    ));

    const downloadFromAPI = (folderPrefix) => {
        const encodedPrefix = toBase64(folderPrefix);
        const url = `https://historyv2.sitgps.com/Tracking/report_by_page_download?prefix=${encodedPrefix}`;
        const a = document.createElement("a");
        a.href = url;
        a.rel = "noopener";
        a.download = folderPrefix.replace(/\/$/, "") + ".zip";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };


    const parseFolderDate = (str) => {
        if (!/^\d{12}$/.test(str)) return null;

        const day = str.substring(0, 2);
        const month = str.substring(2, 4);
        const year = "20" + str.substring(4, 6); // 20YY
        const hour = str.substring(6, 8);
        const min = str.substring(8, 10);
        const sec = str.substring(10, 12);

        return `${day}/${month}/${year} ${hour}:${min}:${sec}`;
    };

    const extractTimestamp = (folderName) => {
        const match = folderName.match(/_(\d{12})_/);
        return parseFolderDate(match ? match[1] : null);
    };

    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
            <DialogTitle>
                รายการไฟล์
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ p: 2, overflow: "auto" }}>


                    {folders.length > 0 ? (
                        <table className="json-to-table" border="1" cellPadding="5" style={{ borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th>ชื่อ</th>
                                    {/* <th>เวลาที่สร้าง</th> */}
                                    <th>สถานะ</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {folders
                                    .sort((a, b) => {
                                        const t1 = parseInt(a.match(/_(\d{12,})_/)[1]);
                                        const t2 = parseInt(b.match(/_(\d{12,})_/)[1]);
                                        return t2 - t1;
                                    }).map((folder, idx) => {
                                        const status = folderStatus[folder] || { filesCount: 0, canDownload: false };
                                        const expectedCount = getExpectedFileCount(folder);
                                        const progressPercent = expectedCount > 0 ? Math.min(100, Math.floor((status.filesCount / expectedCount) * 100)) : 0;

                                        return (
                                            <tr key={`${idx}-${folder}`} className={idx % 2 === 0 ? 'even' : 'odd'}>
                                                <td>{folder.replace(prefix, "").replaceAll("/", "")}</td>
                                                {/* <td>{extractTimestamp(folder.replace(prefix, "").replaceAll("/", ""))}</td> */}
                                                <td style={{ width: "200px" }}>
                                                    <div style={{ height: "10px", width: "100%", background: "#ccc", borderRadius: "5px", overflow: "hidden" }}>
                                                        <div style={{
                                                            height: "10px",
                                                            width: `${progressPercent}%`,
                                                            background: progressPercent === 100 ? "#4caf50" : "#f39c12",
                                                            borderRadius: "5px",
                                                            transition: "width .3s"
                                                        }} />
                                                    </div>
                                                    <div style={{ fontSize: "12px", textAlign: "center" }}>{`(${status.filesCount} / ${expectedCount}) ${progressPercent}%`}</div>


                                                </td>
                                                <td style={{ textAlign: "center", width: "260px" }}>
                                                    <Button
                                                        onClick={() => downloadFromAPI(folder)}
                                                        disabled={!status.canDownload}
                                                        variant="contained"
                                                        color="success"
                                                        size="small"
                                                    >
                                                        Download
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    ) : (
                        <div style={{ textAlign: "center" }}>ไม่มีข้อมูล</div>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" size="small" onClick={loadStatus}>
                    Reload
                </Button>
            </DialogActions>
        </Dialog>
    );
}
